// angular import
import { Component } from '@angular/core';

// project import
import { SharedModule } from 'src/app/theme/shared/shared.module';import { MenuRightsService } from '../../../../../theme/shared/service/menu_rights.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-nav-left',
    imports: [SharedModule],
    templateUrl: './nav-left.component.html',
    styleUrls: ['./nav-left.component.scss']
})
export class NavLeftComponent {

    menuRights: any = {}

    private _unsubscribeAll: Subject<any>;

    constructor(private MenuRightsService: MenuRightsService) {

        this._unsubscribeAll = new Subject();

        this.MenuRightsService.menuData$.pipe(takeUntil(this._unsubscribeAll)).subscribe((data) => {
            this.menuRights = data ?? {};
        });
    }
}
